import React from 'react'
import cn from 'classnames'

import Dialog from '../../../components/dialog/Dialog'

import styles from './PaymentActionDialog.module.scss'

const PaymentActionDialog = ({ title, message, onCancel, onUpdate, onClose, className }) => {
  const classNames = cn(styles.paymentActionDialog, className)

  return (
    <Dialog title={title} message={message} onClose={onClose} className={classNames}>
      <div className={styles.buttonGroup}>
        <button onClick={onUpdate}>Update</button>
        <button onClick={onCancel}>Cancel Tender</button>
      </div>
    </Dialog>
  )
}

export default PaymentActionDialog
